import React, { useContext, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { useProfile } from './UserProfileContext';

const AgencyContext = React.createContext();

export function useAgency() {
    return useContext(AgencyContext);
}

export function AgencyProvider({ children }) {
    const [agency, setAgency] = useState({});
    const [shouldFetchAgencyData, setShouldFetchAgencyData] = useState(false);
    const { profile } = useProfile();
    const isAgency = profile?.isAgency;

    console.log(isAgency, 'profile');

    const { currentUser } = useAuth();
    const { accessToken, isAuthenticated, accountIsComplete, emailIsVerified } = { ...currentUser };

    const accountIsLoaded = accessToken && isAuthenticated && accountIsComplete && emailIsVerified;

    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${accessToken}`,
    };

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const fetchData = async () => {
        const agencyData = await axios.get(`${baseURL}/getAgency`, { headers });

        setAgency({
            ...agencyData?.data,
        });
    };

    useEffect(() => {
        if (shouldFetchAgencyData === true) {
            fetchData();
            setShouldFetchAgencyData(false);
        }
    }, [shouldFetchAgencyData]);

    //forces it to fetch on login
    useEffect(() => {
        if (accountIsLoaded && isAgency) {
            fetchData();
        }
    }, [accessToken, isAuthenticated, accountIsComplete, emailIsVerified, isAgency]);

    const value = {
        agency,
        setAgency,
        setShouldFetchAgencyData,
    };

    return <AgencyContext.Provider value={value}>{children}</AgencyContext.Provider>;
}

AgencyProvider.propTypes = {
    children: propTypes.node.isRequired,
};
